/**
 * Geometry of the board leftnav rail, for the overlays that must work around it.
 *
 * Its own module rather than an export on BoardLeftNavRail: the rail is a
 * component file, and a component file that also exports helpers breaks React
 * Fast Refresh (`react-refresh/only-export-components`). It is shared by the
 * rail's tests and by BoardCanvas's card-preview backdrop.
 */

/**
 * The rail's expanded width in px. Mirrors the `w-20` on the rail — Tailwind's
 * spacing scale puts `w-20` at 5rem/80px — and exists because an overlay that
 * must NOT cover the rail has to know where it ends. One source of truth so the
 * overlay cannot drift out of alignment with the rail it is avoiding; a test
 * asserts the class and this constant still agree.
 */
export const BOARD_LEFTNAV_WIDTH_PX = 80

/**
 * Where a full-screen board overlay must start so it does not cover the rail.
 *
 * The answer is a property of the RAIL, not of the overlay, which is why it lives
 * here rather than inline at the backdrop. Returns 0 whenever no rail is on
 * screen — collapsed, or a layout that never mounts one (V1, embed) — so the
 * overlay covers the full width exactly as it did before.
 */
export function boardOverlayInsetStartPx(railMounted: boolean, expanded: boolean): number {
  return railMounted && expanded ? BOARD_LEFTNAV_WIDTH_PX : 0
}
